import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { allocations } from "../../api/endpoints/allocations";
import { qk } from "../../api/queryKeys";
import { ErrorBanner } from "../../components/ui/ErrorBanner";

export function AllocateSiteInline({
  siteSlug, canWrite, gateOk, onAllocated,
}: {
  siteSlug: string; canWrite: boolean; gateOk: boolean; onAllocated: () => void;
}) {
  const qc = useQueryClient();
  const preview = useQuery({
    queryKey: qk.allocationPreview("site", siteSlug),
    queryFn: () => allocations.preview({ kind: "site", site_slug: siteSlug }).then((r) => r.data),
  });
  const commit = useMutation({
    mutationFn: () => allocations.allocateSite({ site_slug: siteSlug }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: qk.allocationLedger() });
      void qc.invalidateQueries({ queryKey: qk.allocationGate() });
      onAllocated();
    },
  });

  return (
    <div style={{ padding: 12, border: "1px solid var(--border)", borderRadius: 8 }}>
      <div className="label">SITE · {siteSlug}</div>
      <p>Status: <strong>not allocated</strong></p>
      {preview.isPending && <p style={{ color: "var(--text-dim)" }}>Computing next-free block…</p>}
      {preview.error && <ErrorBanner error={preview.error} title="Preview failed" />}
      {preview.data && (
        <>
          <p>Next free block (policy): <strong>{preview.data.cidr ?? "—"}</strong></p>
          <button
            type="button"
            disabled={!canWrite || !gateOk || !preview.data.cidr || commit.isPending}
            onClick={() => commit.mutate()}
          >
            {commit.isPending ? "Allocating…" : "Allocate block"}
          </button>
        </>
      )}
      {commit.error && <ErrorBanner error={commit.error} title="Allocation failed" />}
    </div>
  );
}
